<template>
  <div v-if="menu">
    <router-link to="/admin/calendar"
      ><i class="go-back-button"></i
    ></router-link>
    <h1>Menu editor</h1>
    <div class="menu-contents">
      <MenuSection
        v-for="section of ['starters', 'mains', 'desserts']"
        :isEconomic="false"
        :key="`${JSON.stringify(menu[section], null, 2)}-${section}`"
        :section="section"
        :title="menuSections[section]"
        :plates="menu[section]"
        @add-plate="onAddPlateButtonClicked"
        @edit-plate="onEditPlateButtonClicked"
        @delete-plate="onDeletePlateButtonClicked"
        @copy-plates="onCopyPlatesButtonClicked"
      ></MenuSection>
      <hr />
      <MenuSection
        :isEconomic="true"
        section="economic"
        :title="menuSections['economic']"
        :key="`${JSON.stringify(menu['economic'], null, 2)}-economic`"
        :plates="menu['economic']"
        @edit-plate="onEditPlateButtonClicked"
        @copy-plates="onCopyPlatesButtonClicked"
      ></MenuSection>
    </div>
    <div v-if="showDialog">
      <PlateEditDialog
        :plate="plateToUpdate"
        :title="sectionToUpdate"
        @save-plate="onSavePlateButtonClicked"
        @cancel-save-plate="onCancelSavePlateActionPerformed"
      ></PlateEditDialog>
    </div>
    <div class="button-wrapper">
      <router-link to="/admin/calendar"
        ><div class="button save" @click="onSaveMenuButtonClicked">
          Guardar
        </div></router-link
      >
    </div>
  </div>
</template>

<script>
import api from "@/services/api";
import { generateId } from "@/helper/utils.js";
import MenuSection from "./MenuSection.vue";
import PlateEditDialog from "./PlateEditDialog.vue";
import menuSectionsJSON from "@/assets/menuSections.json";
import allergensJSON from "@/assets/allergens.json";

export default {
  name: "MenuEdit",
  components: {
    PlateEditDialog,
    MenuSection,
  },
  data() {
    return {
      menuSections: menuSectionsJSON,
      allergens: allergensJSON,
      menu: null,
      showDialog: false,
      plateToUpdateIndex: -1,
      plateToUpdate: { text: "", allergens: [] },
      sectionToUpdate: "",
      lastMenu: null,
    };
  },
  methods: {
    onAddPlateButtonClicked(section) {
      this.sectionToUpdate = section;
      this.showDialog = true;
    },
    onCopyPlatesButtonClicked(section) {
      this.menu[section] = this.lastMenu[section];
    },
    onEditPlateButtonClicked(section, index) {
      this.sectionToUpdate = section;
      this.plateToUpdate = this.menu[section][index];
      this.plateToUpdateIndex = index;
      this.showDialog = true;
    },
    onSavePlateButtonClicked(plate) {
      this.showDialog = false;
      if (this.plateToUpdateIndex == -1) {
        this.menu[this.sectionToUpdate].push(plate);
      } else {
        this.menu[this.sectionToUpdate][this.plateToUpdateIndex] = plate;
      }
      this.plateToUpdate = { text: "", allergens: [] };
      this.sectionToUpdate = "";
      this.plateToUpdateIndex = -1;
    },
    onCancelSavePlateActionPerformed() {
      this.showDialog = false;
      this.plateToUpdate = { text: "", allergens: [] };
      this.sectionToUpdate = "";
    },
    onDeletePlateButtonClicked(section, targetIndex) {
      this.menu[section] = this.menu[section].filter(
        (value, index) => index != targetIndex
      );
    },
    async getMenu() {
      const date = this.$route.params.date;
      let menu = await api.getMenuByDate(date);
      if (menu == undefined) {
        menu = {
          id: generateId(),
          date: date,
          starters: [],
          mains: [],
          desserts: [],
          economic: [
            { text: "", allergens: [] },
            { text: "", allergens: [] },
          ],
        };
      }
      this.menu = menu;
      console.log(this.menu);
    },
    async onSaveMenuButtonClicked() {
      await api.saveMenu(this.menu);
      alert("El Menú se ha guardado");
    },
  },
  async created() {
    await this.getMenu();
    const limitDate = this.$route.params.date;
    this.lastMenu = await api.getLastMenu(limitDate);
  },
};
</script>

<style scoped>
h1 {
  text-align: center;
}

.menu-contents {
  margin-bottom: 2rem;
}

.economic-plate-container:last-child {
  margin-top: 2rem;
}

.economic-plate-container p {
  font-weight: 900;
  font-size: 0.9rem;
  margin: 0;
}

input[type="text"] {
  margin: 0.5rem 0;
  width: 100%;
}

.allergens-container {
  display: flex;
  flex-wrap: wrap;
}

label {
  display: block;
  margin: 0.2rem 0.3rem 0 1rem;
}

.button-wrapper {
  display: flex;
  justify-content: center;
}

.button {
  box-sizing: content-box;
  background-color: rgb(48, 65, 163);
  color: white;
  padding: 0.5rem 1rem;
  display: flex;
  align-items: center;
  font-size: 0.8rem;
  font-weight: 900;
  border-radius: 3px;
}

.button:hover {
  cursor: pointer;
  opacity: 0.8;
}

.button.save {
  text-align: center;
  max-width: 5rem;
  padding: 0.75rem 1.25rem;
  font-size: 1.2rem;
  margin: 1rem 0;
  background-color: rgb(48, 65, 163);
}

a {
  text-decoration: none;
  color: black;
}
.go-back-button {
  height: 40px;
  width: 40px;
  background-image: url("~@/assets/go-back-button.png");
  background-size: cover;
  display: inline-block;
  float: left;
}
</style>
